"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyProjectController = exports.EmptyProject = exports.ViewToShow = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var DropzonesStore_1 = require("Project/BlockNew/SavedBlockDropzone/DropzonesStore");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var SavedBlockDropzone_1 = require("Project/BlockNew/SavedBlockDropzone/SavedBlockDropzone");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var blank_slate_svg_1 = __importDefault(require("@ClientAssets/icons/blank-slate.svg"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var ViewToShow;
(function (ViewToShow) {
    ViewToShow["BlankSlate"] = "blankslate";
    ViewToShow["DraggingOver"] = "draggingover";
    ViewToShow["Inserting"] = "inserting";
})(ViewToShow || (exports.ViewToShow = ViewToShow = {}));
var EmptyProject = (0, mobx_react_1.observer)(function (_a) {
    var view = _a.view, onDragOver = _a.onDragOver, createBlockButton = _a.createBlockButton;
    var showBlankSlateView = view === ViewToShow.BlankSlate;
    return (react_1.default.createElement("div", { className: "empty-project" },
        react_1.default.createElement("div", { onDragOver: onDragOver, className: "empty-project__content" }, showBlankSlateView ? (react_1.default.createElement("div", { className: "empty-project__blank-slate" },
            react_1.default.createElement(kaleidoscope_1.SVG, { className: "empty-project__blank-slate-icon", src: blank_slate_svg_1.default }),
            react_1.default.createElement("div", { className: "empty-project__blank-slate-heading" }, "It's a blank slate!"),
            react_1.default.createElement("div", { className: "empty-project__blank-slate-text" }, "Use the '+' button below to add new or saved blocks to your page"))) : (react_1.default.createElement(SavedBlockDropzone_1.SavedBlockDropzoneInner, { isActive: view === ViewToShow.DraggingOver, isOpen: true, isInserting: view === ViewToShow.Inserting, onDragOver: onDragOver, configuration: SavedBlockDropzone_1.SavedBlockDropzoneConfiguration.EmptyProject }))),
        createBlockButton));
});
exports.EmptyProject = EmptyProject;
var EmptyProjectController = (0, mobx_react_1.observer)(function (_a) {
    var blockList = _a.blockList, dropzonesStore = _a.dropzonesStore, dragStore = _a.dragStore, renderCreateBlockButton = _a.renderCreateBlockButton, usingFeature = _a.usingFeature;
    if (blockList.blocks.length > 0 || !usingFeature(FeatureFlag_1.default.Sidebar)) {
        return null;
    }
    var view = getViewToShow(dropzonesStore);
    var onDragOver = function (event) {
        event.preventDefault();
        if (dragStore.dragItemIfCurrent(DragStore_1.DragType.SavedBlock)) {
            dropzonesStore.onOverDropzone(0);
        }
    };
    var createBlockButton = renderCreateBlockButton();
    return react_1.default.createElement(EmptyProject, { view: view, onDragOver: onDragOver, createBlockButton: createBlockButton });
});
exports.EmptyProjectController = EmptyProjectController;
var getViewToShow = function (dropzonesStore) {
    var isCurrentDropzone = dropzonesStore.currentDropzone.index === 0;
    if (!isCurrentDropzone) {
        return ViewToShow.BlankSlate;
    }
    var isActiveDropzone = dropzonesStore.currentDropzone.status === DropzonesStore_1.CurrentDropzoneState.Active;
    return isActiveDropzone ? ViewToShow.DraggingOver : ViewToShow.Inserting;
};
